import { useState, useCallback, useMemo } from "react";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { processError } from "../../../../common/utils/base_error";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { evaluateParamValue } from "../../../../common/utils/params_utils";
import { useCreateDebounceHandler, useDebouncedCallback } from "../../../../common/hooks/use_debounced_callback";
import { useUserAuthStore } from "../../../../stores/global/userAuth";
import { useReportViewer } from "../../../../config/hooks/utils/report_viewer";
import { useEntregaObrasClienteListaFilters } from "../hooks/entrega_obra_cliente_lista/filters";
import { useEntregaObrasClienteListaPagination } from "../hooks/entrega_obra_cliente_lista/pagination";
import { EntregaObraClienteArquivoModel } from "../../domain/models/entrega_obra_cliente_arquivo";
import { EntregaObraClienteLista } from "../../domain/models/entrega_obra_cliente_lista";
import { useChangeHistory } from "../../../../common/hooks/use_change_history";
import { EntregaObraParametros } from "../../domain/models/entrega_obra_parametros";
import { EntregaObraClienteCadastroForm } from "../schemas/entrega_obra_cliente_lista/entregaObraClienteCadastro";
import { useLocation, useNavigate } from "react-router";
import { LogTipoTabela } from "../../../../common/utils/log_tabela_tipo";
import { DropDown } from "../../../../common/domain/models/dropdown";
import { EntregaObraClienteArquivoForm } from "../schemas/entrega_obra_cliente_lista/entregaObraClienteArquivoCadastro";
import { EntregaObraClienteReportFotoForm } from "../schemas/entrega_obra_cliente_verificacao/entregaObraClienteReportFoto";
import { EntregaObraClienteReportGeralForm } from "../schemas/entrega_obra_cliente_lista/entregaObraClienteReportGeral";
import { EntregaObraGrafico } from "../../domain/models/entrega_obra_cliente_grafico";
import { FileUtils } from "../../../../common/utils/file_utils";

/**
 * LoadFuncState
 */

type LoadVistoriasListaFuncState = {
  idsClientes?: number[],
  idsChecklist?: number[],
  tipoVistoria?: number,
  entregue?: number,
  unidade?: string,
  localVistoria?: string,
  dataDe?: Date,
  dataAte?: Date,

  currentPage?: number;
  rowsPerPage?: number;
};

/**
 * useEntregaObrasClienteListaViewModel
 */

export const useEntregaObrasClienteListaViewModel = () => {
  const { idUsuario } = useUserAuthStore();

  const {
    commons: {
      getAllLogAlteracaoUseCase,
      getAllLogAlteracaoByParentUseCase,
      getClientesDropDownUseCase,
      getCentroCustoDropDownUseCase,
      getChecklistEntregaObraDropDownUseCase,

      getEntregaObraReportGeralDropDownUseCase,
    },
    reports: {
      getReportEntregaObraClienteSimplesUseCase,
      getReportEntregaObraClienteFotografico1UseCase,
      getReportEntregaObraClienteFotografico2UseCase,
      getReportEntregaObraClienteGeralUseCase,
      // getReportEntregaObraClienteLoteUseCase,
    },
    entregaObras: {
      getEntregaObrasParametrosUseCase,
      getAllEntregaObrasClienteArquivoUseCase,
      getAllEntregaObrasClienteUseCase,
      getEntregaObrasClienteArquivoByIdUseCase,
      createEntregaObrasClienteUseCase,
      createEntregaObrasClienteArquivoUseCase,
      updateEntregaObrasClienteArquivoUseCase,
      deleteEntregaObrasClienteArquivoUseCase,
      deleteEntregaObrasClienteUseCase,
      getEntregaObraGraficoUseCase,
      downloadEntregaObraClienteArquivoByIdUseCase,
    },

  } = useDependencyInjection();

  const {
    pushInfoNotification,
    pushWarnNotification,
    pushErrorNotification,
    setCustomLoading,

  } = usePageLoader();

  const location = useLocation();
  const navigate = useNavigate();

  const debouncedRef = useCreateDebounceHandler(1500);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const [entregaObraParametros, setEntregaObraParametros] = useState<EntregaObraParametros>();
  const [selectedIdEntregaObra, setSelectedIdEntregaObra] = useState<number | null>();

  //listas
  const [arquivosLista, setArquivosLista] = useState<EntregaObraClienteArquivoModel[]>();
  const [vistoriasLista, setVistoriasLista] = useState<EntregaObraClienteLista[]>();


  //Arquivos modal
  const [selectedArquivo, setSelectedArquivo] = useState<EntregaObraClienteArquivoModel | undefined>();
  const [openCadastroArquivosModal, setOpenCadastroArquivosModal] = useState(false);
  const [openDeleteArquivosModal, setOpenDeleteArquivosModal] = useState(false);
  const [selectedIdArquivosDelete, setSelectedIdArquivosDelete] = useState<number>();

  //Vistoria modal
  const [selectedIdVistoriasDelete, setSelectedIdVistoriasDelete] = useState<number>();
  const [openCadastroVistoriasModal, setOpenCadastroVistoriasModal] = useState(false);
  const [openDeleteVistoriasModal, setOpenDeleteVistoriasModal] = useState(false);


  const filters = useEntregaObrasClienteListaFilters();
  const pagination = useEntregaObrasClienteListaPagination();

  const [ddlCentroCusto, setDdlCentroCusto] = useState<DropDown[]>();
  const [ddlCliente, setDdlCliente] = useState<DropDown[]>();
  const [ddlChecklistEntregaObra, setDdlChecklistEntregaObra] = useState<DropDown[]>();

  const [ddlClienteReport, setDdlClienteReport] = useState<DropDown[]>();
  const [ddlUnidadeReport, setDdlUnidadeReport] = useState<DropDown[]>();
  const [ddlChecklistReport, setDdlChecklistReport] = useState<DropDown[]>();
  const [ddlLocalVistoriaReport, setDdlLocalVistoriaReport] = useState<DropDown[]>();

  //RELATORIOS

  const [reportViewerState, startReportViewerProcess] = useReportViewer();
  const [openReportFotoModal, setOpenReportFotoModal] = useState(false);
  const [openReportGeralModal, setOpenReportGeralModal] = useState(false);
  const [selectedIdVistoriaReport, setSelectedIdVistoriaReport] = useState<number | null>(null);
  const [nroFotoReport, setNroFotoReport] = useState<number | null>(null);

  const [openGraficoModal, setOpenGraficoModal] = useState(false);
  const [estatisticasChecklist, setEstatisticasChecklist] = useState<EntregaObraGrafico>();


  const changeHistory = useChangeHistory({
    getAllLogAlteracaoUseCase,
    getAllLogAlteracaoByParentUseCase,
    onSetError: (e) => pushErrorNotification('Erro', [e]),
  })

  //#region CARREGAMENTO

  const loadVistoriasLista = useCallback(async (funcState?: LoadVistoriasListaFuncState, idEntregaObra?: number) => {
    try {

      setLoading(true);
      const filteredIdsClientes = evaluateParamValue(funcState?.idsClientes, filters.idsClientes);
      const filteredIdsChecklist = evaluateParamValue(funcState?.idsChecklist, filters.idsChecklist);
      const filteredTipoVistoria = evaluateParamValue(funcState?.tipoVistoria, filters.tipoVistoria);
      const filteredEntregue = evaluateParamValue(funcState?.entregue, filters.entregue);
      const filteredUnidade = evaluateParamValue(funcState?.unidade, filters.unidade);
      const filteredLocalVistoria = evaluateParamValue(funcState?.localVistoria, filters.localVistoria);
      const filteredDataDe = evaluateParamValue(funcState?.dataDe, filters.dataDe);
      const filteredDataAte = evaluateParamValue(funcState?.dataAte, filters.dataAte);

      const filteredCurrentPage = evaluateParamValue(funcState?.currentPage, pagination.page);
      const filteredRowsPerPage = evaluateParamValue(funcState?.rowsPerPage, pagination.rowsPerPage);

      const filteredIdEntregaObra = idEntregaObra ?? selectedIdEntregaObra ?? 0;

      await getAllEntregaObrasClienteUseCase.execute(
        filteredIdEntregaObra,
        filteredIdsClientes ?? [],
        filteredIdsChecklist ?? [],
        filteredTipoVistoria ?? 2,
        filteredEntregue ?? 2,
        filteredUnidade ?? "",
        filteredLocalVistoria ?? "",
        filteredDataDe ?? undefined,
        filteredDataAte ?? undefined,
        filteredCurrentPage ?? 1,
        filteredRowsPerPage ?? 100,
      );

      setVistoriasLista(getAllEntregaObrasClienteUseCase.items);

      pagination.setRowsPerPage(getAllEntregaObrasClienteUseCase.pageSize);
      pagination.setTotalItems(getAllEntregaObrasClienteUseCase.totalItems);
    } catch (e: unknown) {
      setVistoriasLista([]);
      pushErrorNotification("Error", processError(e, "Falha ao buscar lista de vistorias!"), { isAutoFinish: true });
    } finally {
      setLoading(false);
    }
  }, [
    selectedIdEntregaObra,
    filters,
    pagination,
    getAllEntregaObrasClienteUseCase,
    pushErrorNotification

  ]);

  const loadEntregaObraGrafico = useCallback(async (id?: number) => {
    try {
      if (!selectedIdEntregaObra) {
        return;
      }
      const filteredIdObraChecklistServico = id ?? selectedIdEntregaObra;
      const response = await getEntregaObraGraficoUseCase.execute(
        filteredIdObraChecklistServico,
      );
      setEstatisticasChecklist(response);
    } catch (e: unknown) {
      setEstatisticasChecklist(undefined);
      throw new Error("Falha ao buscar dados da pagina!");
    }
  }, [
    selectedIdEntregaObra,
    getEntregaObraGraficoUseCase,
  ]);

  const loadArquivosLista = useCallback(async (idEntregaObra: number) => {
    try {
      setLoading(true);
      await getAllEntregaObrasClienteArquivoUseCase.execute(idEntregaObra);
      setArquivosLista(getAllEntregaObrasClienteArquivoUseCase.items);

    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar checklist de entrega!'));
    } finally {
      setLoading(false);
    }
  }, [
    getAllEntregaObrasClienteArquivoUseCase,
    pushErrorNotification]);


  const loadArquivoById = useCallback(async (idEntregaObraClienteArquivo: number) => {
    try {
      setLoading(true);
      const result = await getEntregaObrasClienteArquivoByIdUseCase.execute(idEntregaObraClienteArquivo);
      setSelectedArquivo(result);

    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar checklist de entrega!'));
    } finally {
      setLoading(false);
    }
  }, [
    getEntregaObrasClienteArquivoByIdUseCase,
    pushErrorNotification]);

  const loadParametrosEntregaObrasById = useCallback(async (idEntregaObra: number) => {
    try {
      setLoading(true);
      const result = await getEntregaObrasParametrosUseCase.execute(idEntregaObra);
      setEntregaObraParametros(result);

    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar parâmetros de entrega!'));
    } finally {
      setLoading(false);
    }
  }, [
    getEntregaObrasParametrosUseCase,
    pushErrorNotification]);


  const loadCentroCustoDropDown = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getCentroCustoDropDownUseCase.getCentroCustoDropDown();
      setDdlCentroCusto(response);
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar lista de centros de custo!'));
    } finally {
      setLoading(false);
    }
  }, [getCentroCustoDropDownUseCase,
    pushErrorNotification]);


  const loadClienteDropDown = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getClientesDropDownUseCase.getClientesDropDown();
      setDdlCliente(response);
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar lista de clientes!'));
    } finally {
      setLoading(false);
    }
  }, [getClientesDropDownUseCase,
    pushErrorNotification]);


  const loadChecklistEntregaObraDropDown = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getChecklistEntregaObraDropDownUseCase.getChecklistEntregaObraDropDown();
      setDdlChecklistEntregaObra(response);
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar lista de checklists de entrega!'));
    } finally {
      setLoading(false);
    }
  }, [
    getChecklistEntregaObraDropDownUseCase,
    pushErrorNotification
  ]);


  const filteredChecklistEntregaObraDropdown = useMemo(() => {
    return ddlChecklistEntregaObra
      ? ddlChecklistEntregaObra.filter(x => {

        return x.ativo === true;
      })
      : null;
  }, [
    ddlChecklistEntregaObra
  ]);

  //#endregion




  //#region  Dropdowns Relatorios e gráficos

  const loadReportDropDown = useCallback(async (idEntregaObra: number, tipo: string) => {
    try {
      setLoading(true);
      const response = await getEntregaObraReportGeralDropDownUseCase.execute(idEntregaObra, tipo);

      switch (tipo) {
        case 'cliente':
          setDdlClienteReport(response);
          break;
        case 'unidade':
          setDdlUnidadeReport(response);
          break;
        case 'localVistoria':
          setDdlLocalVistoriaReport(response);
          break;
        case 'checklist':
          setDdlChecklistReport(response);
          break;
      }

    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar lista de clientes!'));
    } finally {
      setLoading(false);
    }
  }, [getEntregaObraReportGeralDropDownUseCase,
    pushErrorNotification]);


  //#endregion

  //#region CABEÇALHO (implementar)

  const handlePageBack = useCallback(() => {
    navigate('/EntregaObras_lista');
  }, [navigate]);


  const handleNewContaPagar = useCallback(() => {

  }, []);


  const handleItemVerificacaoPage = useCallback(async (idEntregaObraCliente: number | null, openNewTab: boolean) => {
    try {
      if (openNewTab) {
        window.open(`/EntregaObrasCliente_verificacao?id=${idEntregaObraCliente}`, "_blank", "noopener,noreferrer");
      } else {
        navigate(`/EntregaObrasCliente_verificacao?id=${idEntregaObraCliente}`);
      }
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao navegar para página de item de verificação!"));
    }
  }, [navigate, pushErrorNotification]);


  //#endregion





  //#region PAGE START

  usePageStartBootstrap(async () => {
    try {
      const params = new URLSearchParams(location.search);
      const locationId = params.get("id");
      const id = locationId ? Number(locationId) : null;

      if (id === null) {
        pushErrorNotification("Erro", "Nenhum id de obra de entrega fornecido!", { isAutoFinish: true });
        return;
      }
      const jobs = [];

      setErrorMessage(undefined);
      setSelectedIdEntregaObra(id);

      await loadVistoriasLista({});
      jobs.push(loadVistoriasLista({ currentPage: 1, rowsPerPage: 100 }, id));
      jobs.push(loadArquivosLista(id));
      jobs.push(loadParametrosEntregaObrasById(id));
      jobs.push(loadCentroCustoDropDown());
      jobs.push(loadClienteDropDown());
      jobs.push(loadChecklistEntregaObraDropDown());
      jobs.push(loadEntregaObraGrafico(id));
      jobs.push(loadReportDropDown(id, 'cliente'));
      jobs.push(loadReportDropDown(id, 'unidade'));
      jobs.push(loadReportDropDown(id, 'localVistoria'));
      jobs.push(loadReportDropDown(id, 'checklist'));

      await Promise.all(jobs);
    } catch (e: unknown) {
      setErrorMessage(processError(e, "Falha ao salvar o cargo!")[0]);
    }
  });


  //#endregion




  //#region NOVA VISTORIA.

  const handleVistoriaOpenState = useCallback(async (openState: boolean) => {
    setOpenCadastroVistoriasModal(openState);

  }, []);

  const handleSubmitNewVistoria = useCallback(async (form: EntregaObraClienteCadastroForm) => {
    try {
      setSaving(true);

      if (!selectedIdEntregaObra) {
        pushErrorNotification("Atenção", "Selecione uma obra de entrega para adicionar uma vistoria!", { isAutoFinish: true });
        return;
      }

      if (form.tipoVistoriaCliente === false && form.tipoVistoriaConstrutora === false) {
        pushErrorNotification("Atenção", "Selecione ao menos um tipo de vistoria (Cliente ou Construtora)!", { isAutoFinish: true });
        return;
      }

      if (form.idsChecklistEntrega.length === 0) {
        pushErrorNotification("Atenção", "Selecione ao menos um item de checklist para a vistoria!", { isAutoFinish: true });
        return;
      }

      if (form.idsChecklistEntrega.length > 20) {
        pushErrorNotification("Atenção", "Selecione no máximo 20 itens de checklist para a vistoria!", { isAutoFinish: true });
        return;
      }

      if (!entregaObraParametros) {
        pushErrorNotification("Atenção", "Parâmetros da obra de entrega não encontrados!", { isAutoFinish: true });
        return;
      }

      await createEntregaObrasClienteUseCase.execute(
        selectedIdEntregaObra ?? 0,
        form.idCliente ?? 0,
        entregaObraParametros?.idCentroCusto,
        form.idsChecklistEntrega,
        form.clienteCadastrado,
        form.descCliente,
        form.tipoVistoriaCliente,
        form.tipoVistoriaConstrutora,
        form.localVistoria,
        form.status

      );

      await loadVistoriasLista();
      pushInfoNotification("Sucesso", "Vistoria criada com sucesso!", { isAutoFinish: true });

    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao salvar item do Checklist de entrega!"));
    } finally {
      setSaving(false);
      setOpenCadastroVistoriasModal(false);
    }
  }, [
    selectedIdEntregaObra,
    entregaObraParametros,
    createEntregaObrasClienteUseCase,
    loadVistoriasLista,
    pushErrorNotification,
    pushInfoNotification]);

  //#endregion






  //#region NOVO ARQUIVO.

  const handleArquivoModalOpenState = useCallback(async (idEntregaObra: number | null, openState: boolean) => {
    setOpenCadastroArquivosModal(openState);
    if (idEntregaObra && openState) {
      await loadArquivoById(idEntregaObra ?? 0);
    } else {
      setSelectedArquivo(undefined);
    }
  }, [
    loadArquivoById,
  ]);

  const handleSubmitNewArquivo = useCallback(async (form: EntregaObraClienteArquivoForm) => {
    try {

      setSaving(true);
      if (!selectedIdEntregaObra) {
        pushErrorNotification("Atenção", "Selecione uma obra de entrega para adicionar um arquivo!", { isAutoFinish: true });
        return;
      }
      if (form.arquivo !== null) FileUtils.validateFileSize(form.arquivo);

      if (selectedArquivo) {
        await updateEntregaObrasClienteArquivoUseCase.execute(
          form.idEntregaObraClienteArquivo ?? 0,
          selectedIdEntregaObra ?? 0,
          form.descricao,
          form.arquivo ?? undefined,
          form.limparArquivo
        );
      } else {
        await createEntregaObrasClienteArquivoUseCase.execute(
          selectedIdEntregaObra ?? 0,
          form.descricao,
          form.arquivo ?? undefined,
        );
      }

      await loadArquivosLista(selectedIdEntregaObra);
      pushInfoNotification("Sucesso", "Arquivo criado com sucesso!", { isAutoFinish: true });

    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao salvar item do Checklist de entrega!"));
    } finally {
      setOpenCadastroArquivosModal(false);
      setSaving(false);
    }
  }, [
    selectedIdEntregaObra,
    selectedArquivo,
    createEntregaObrasClienteArquivoUseCase,
    updateEntregaObrasClienteArquivoUseCase,
    loadArquivosLista,
    pushErrorNotification,
    pushInfoNotification]);

  //#endregion





  //#region DELETE ARQUIVO.

  const handleDeleteArquivoOpenState = useCallback(async (idEntregaObraClienteArquivo: number | null, openState: boolean) => {
    setSelectedIdArquivosDelete(idEntregaObraClienteArquivo ?? undefined);
    setOpenDeleteArquivosModal(openState);
  }, []);

  const handleSubmitDeleteArquivo = useCallback(async () => {
    try {
      if (!selectedIdArquivosDelete) {
        pushWarnNotification("Atenção", "Nenhum arquivo selecionado!", { isAutoFinish: true });
        return;
      }

      setSaving(true);
      await deleteEntregaObrasClienteArquivoUseCase.execute(selectedIdArquivosDelete);

      await loadArquivosLista(selectedIdEntregaObra!);
      setOpenDeleteArquivosModal(false);
      pushInfoNotification("Sucesso", "Arquivo deletado com sucesso!", { isAutoFinish: true });

    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao deletar arquivo!"));
    } finally {
      setSaving(false);
    }
  }, [
    selectedIdArquivosDelete,
    deleteEntregaObrasClienteArquivoUseCase,
    selectedIdEntregaObra,
    loadArquivosLista,
    pushErrorNotification,
    pushInfoNotification,
    pushWarnNotification
  ]);

  //#endregion






  //#region DELETE VISTORIA.

  const handleDeleteVistoriaOpenState = useCallback(async (idEntregaObraClienteVistoria: number | null, openState: boolean) => {
    setSelectedIdVistoriasDelete(idEntregaObraClienteVistoria ?? undefined);
    setOpenDeleteVistoriasModal(openState);
  }, []);

  const handleSubmitDeleteVistoria = useCallback(async () => {
    try {
      if (!selectedIdVistoriasDelete) {
        pushWarnNotification("Atenção", "Nenhuma vistoria selecionada!", { isAutoFinish: true });
        return;
      }

      setSaving(true);
      await deleteEntregaObrasClienteUseCase.execute(selectedIdVistoriasDelete);

      await loadArquivosLista(selectedIdEntregaObra!);
      await loadVistoriasLista();
      setOpenDeleteVistoriasModal(false);
      pushInfoNotification("Sucesso", "Vistoria deletada com sucesso!", { isAutoFinish: true });

    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao deletar vistoria!"));
    } finally {
      setSaving(false);
    }
  }, [
    selectedIdEntregaObra,
    selectedIdVistoriasDelete,
    deleteEntregaObrasClienteUseCase,
    loadArquivosLista,
    loadVistoriasLista,
    pushErrorNotification,
    pushInfoNotification,
    pushWarnNotification,
    setSaving,
  ]);

  //#endregion







  //#region PAGINAÇÃO.


  const handleReload = useCallback(async () => {
    try {
      setLoading(true);
      await loadVistoriasLista();
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar lista de vistorias!'), { isAutoFinish: true });
    } finally {
      setLoading(false);
    }
  }, [loadVistoriasLista, pushErrorNotification]);

  const handlePageChange = useCallback(async (page: number) => {
    try {
      setLoading(true);
      pagination.setPage(page + 1);
      await loadVistoriasLista({ currentPage: page + 1 });
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar lista de vistorias!'), { isAutoFinish: true });
    } finally {
      setLoading(false);
    }
  }, [pagination, loadVistoriasLista, pushErrorNotification]);

  const handleRowsPerPageChange = useCallback(async (rowsPerPage: number) => {
    try {
      setLoading(true);
      pagination.setPage(1);
      pagination.setRowsPerPage(rowsPerPage);
      await loadVistoriasLista({ rowsPerPage, currentPage: 1 });
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar lista de vistorias!'), { isAutoFinish: true });
    } finally {
      setLoading(false);
    }
  }, [pagination, loadVistoriasLista, pushErrorNotification]);

  //#endregion




  //#region ARQUIVOS
  const handleDownloadArquivo = useCallback(async (idEntregaObraClienteArquivo: number) => {
    try {
      setCustomLoading(true, "Preparando download...");
      if (idEntregaObraClienteArquivo) {
        const nomeArquivo = arquivosLista?.find(arquivo =>
          arquivo.idEntregaObraClienteArquivo === idEntregaObraClienteArquivo)?.nome ?? 'arquivo';
        await downloadEntregaObraClienteArquivoByIdUseCase
          .downloadEntregaObraClienteArquivoById(idEntregaObraClienteArquivo, nomeArquivo);
        return;
      }
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao baixar arquivo!"));
    } finally {
      setCustomLoading(false);
    }
  }, [
    downloadEntregaObraClienteArquivoByIdUseCase,
    arquivosLista,
    setCustomLoading,
    pushErrorNotification,
  ]);

  const handleArquivoDeleteOpenState = useCallback((limparArquivos: string | null, arquivo: string | null, openState: boolean) => {
    if (openState && limparArquivos && arquivo) {
      setOpenDeleteArquivosModal(openState)
    } else {
      setOpenDeleteArquivosModal(openState)
    }
  }, []);

  //#endregion





  //#region PESQUISA.

  const handleIdsChecklistChange = useDebouncedCallback(
    debouncedRef,
    (newValue: number[] | []) => {
      filters.setIdsChecklist(newValue ?? undefined);
      return async () => {
        try {
          setLoading(true);
          pagination.setPage(1);
          await loadVistoriasLista({ idsChecklist: newValue ?? undefined, currentPage: 1 });
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, "Falha ao buscar vistorias!"));
        } finally {
          setLoading(false);
        }
      };
    },
    [filters, pagination, loadVistoriasLista, pushErrorNotification]
  );

  const handleIdsClienteChange = useDebouncedCallback(
    debouncedRef,
    (newValue: number[] | []) => {
      filters.setIdsClientes(newValue ?? undefined);
      return async () => {
        try {
          setLoading(true);
          pagination.setPage(1);
          await loadVistoriasLista({ idsClientes: newValue ?? undefined, currentPage: 1 });
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, "Falha ao buscar vistorias!"));
        } finally {
          setLoading(false);
        }
      };
    },
    [filters, pagination, loadVistoriasLista, pushErrorNotification]
  );

  const handleLocalVistoriaChange = useDebouncedCallback(
    debouncedRef,
    (newValue: string) => {
      filters.setLocalVistoria(newValue ?? undefined);
      return async () => {
        try {
          setLoading(true);
          pagination.setPage(1);
          await loadVistoriasLista({ localVistoria: newValue ?? undefined, currentPage: 1 });
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, "Falha ao buscar vistorias!"));
        } finally {
          setLoading(false);
        }
      };
    },
    [filters, pagination, loadVistoriasLista, pushErrorNotification]
  );

  const handleEntregueChange = useDebouncedCallback(
    debouncedRef,
    (newValue: number) => {
      filters.setEntregue(newValue ?? undefined);
      return async () => {
        try {
          setLoading(true);
          pagination.setPage(1);
          await loadVistoriasLista({ entregue: newValue ?? undefined, currentPage: 1 });
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, "Falha ao buscar vistorias!"));
        } finally {
          setLoading(false);
        }
      };
    },
    [filters, pagination, loadVistoriasLista, pushErrorNotification]
  );

  const handleUnidadeChange = useDebouncedCallback(
    debouncedRef,
    (newValue: string) => {
      filters.setUnidade(newValue ?? undefined);
      return async () => {
        try {
          setLoading(true);
          pagination.setPage(1);
          await loadVistoriasLista({ unidade: newValue ?? undefined, currentPage: 1 });
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, "Falha ao buscar vistorias!"));
        } finally {
          setLoading(false);
        }
      };
    },
    [filters, pagination, loadVistoriasLista, pushErrorNotification]
  );

  const handleDataRangeChange = useDebouncedCallback(
    debouncedRef,
    (dataDe: Date | null, dataAte: Date | null) => {
      filters.setDataDe(dataDe);
      filters.setDataAte(dataAte);
      return async () => {
        try {
          setLoading(true);
          pagination.setPage(1);
          await loadVistoriasLista({ dataDe: dataDe ?? undefined, dataAte: dataAte ?? undefined, currentPage: 1 });
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, "Falha ao buscar vistorias!"));
        } finally {
          setLoading(false);
        }
      };
    },
    [filters, pagination, loadVistoriasLista, pushErrorNotification]
  );

  const handleTipoVistoriaChange = useDebouncedCallback(
    debouncedRef,
    (newValue: number) => {
      filters.setTipoVistoria(newValue ?? undefined);
      return async () => {
        try {
          setLoading(true);
          pagination.setPage(1);
          await loadVistoriasLista({ tipoVistoria: newValue ?? undefined, currentPage: 1 });
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, "Falha ao buscar vistorias!"));
        } finally {
          setLoading(false);
        }
      };
    },
    [filters, pagination, loadVistoriasLista, pushErrorNotification]
  );

  const handleClearFilters = useCallback(async () => {
    try {
      setLoading(true);
      filters.clearFilters();
      pagination.setPage(1);
      await loadVistoriasLista({
        idsClientes: [],
        idsChecklist: [],
        tipoVistoria: 2,
        entregue: 2,
        unidade: "",
        localVistoria: "",
        dataDe: undefined,
        dataAte: undefined,
        currentPage: 1,
        rowsPerPage: pagination.rowsPerPage,
      });
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao limpar filtros!"));
    } finally {
      setLoading(false);
    }
  }, [filters, pagination, loadVistoriasLista, pushErrorNotification]);

  //#endregion






  //#region RELATORIOS

  const handleReportFotoOpenState = useCallback((idVistoria: number | null, openState: boolean, nroReport: number) => {
    setOpenReportFotoModal(openState)
    setNroFotoReport(nroReport);

    if (openState && idVistoria) {
      setSelectedIdVistoriaReport(idVistoria);
    } else {
      setSelectedIdVistoriaReport(null);
      setNroFotoReport(null);

    }

  }, []);


  const handleReportGeralOpenState = useCallback(async (openState: boolean) => {
    setOpenReportGeralModal(openState)
    if (selectedIdEntregaObra && openState) {

    }
  }, [
    selectedIdEntregaObra,
    loadReportDropDown,
  ]);

  const handleReportSimple = useCallback(async (idEntregaObraCliente: number) => {
    try {
      setLoading(true);
      if (!selectedIdEntregaObra) {
        pushWarnNotification("Atenção", "Selecione uma vistoria!", { isAutoFinish: true });
        return;
      }

      await startReportViewerProcess({
        fetchCallback: async (requiredMimeType) =>
          await getReportEntregaObraClienteSimplesUseCase.execute(
            requiredMimeType,
            idEntregaObraCliente,
          ),
      });

    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao gerar relatório!"));
    } finally {
      setLoading(false);
    }
  }, [
    selectedIdEntregaObra,
    getReportEntregaObraClienteSimplesUseCase,
    startReportViewerProcess,
    setLoading,
    pushWarnNotification,
    pushErrorNotification
  ]);



  const handleReportFotografico = useCallback(async (form: EntregaObraClienteReportFotoForm) => {
    try {
      setLoading(true);
      if (!selectedIdVistoriaReport) {
        pushWarnNotification("Atenção", "Selecione uma vistoria!", { isAutoFinish: true });
        return;
      }

      if (nroFotoReport === 1) {
        await startReportViewerProcess({
          fetchCallback: async (requiredMimeType) =>
            await getReportEntregaObraClienteFotografico1UseCase.execute(
              requiredMimeType,
              selectedIdVistoriaReport,
              form.retrabalho !== null ? (form.retrabalho.length > 0 ? form.retrabalho : undefined) : undefined,
            ),
        });

      } else {
        await startReportViewerProcess({
          fetchCallback: async (requiredMimeType) =>
            await getReportEntregaObraClienteFotografico2UseCase.execute(
              requiredMimeType,
              selectedIdVistoriaReport,
              form.retrabalho !== null ? (form.retrabalho.length > 0 ? form.retrabalho : undefined) : undefined,
            ),
        });
      }

    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao gerar relatório!"));
    } finally {
      setLoading(false);
    }
  }, [
    selectedIdVistoriaReport,
    getReportEntregaObraClienteFotografico2UseCase,
    getReportEntregaObraClienteFotografico1UseCase,
    nroFotoReport,
    startReportViewerProcess,
    pushWarnNotification,
    pushErrorNotification,
    setLoading
  ]);


  const handleReportGeral = useCallback(async (form: EntregaObraClienteReportGeralForm) => {
    try {
      setLoading(true);
      if (!selectedIdEntregaObra) {
        pushWarnNotification("Atenção", "Selecione uma vistoria!", { isAutoFinish: true });
        return;
      }

      await startReportViewerProcess({
        fetchCallback: async (requiredMimeType) =>
          await getReportEntregaObraClienteGeralUseCase.execute(
            requiredMimeType,
            selectedIdEntregaObra,
            form.status ?? null,
            form.vistoria ?? null,
            form.idsCliente ?? null,
            form.idsUnidade ?? null,
            form.idsChecklist ?? null,
            form.idsLocalVistoria ?? null,
            form.dataDe,
            form.dataAte,
            idUsuario,
          ),
      });

    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, "Falha ao gerar relatório!"));
    } finally {
      setLoading(false);
    }
  }, [
    selectedIdEntregaObra,
    getReportEntregaObraClienteGeralUseCase,
    idUsuario,
    startReportViewerProcess,
    pushWarnNotification,
    pushErrorNotification,
    setLoading,
  ]);

  //#endregion


  //#region GRAFICO

  const handleGraficoOpenState = useCallback(async (openState: boolean) => {
    setOpenGraficoModal(openState);
    if (selectedIdEntregaObra && openState) {
      await loadEntregaObraGrafico(selectedIdEntregaObra);
    }
  }, [
    selectedIdEntregaObra,
    loadEntregaObraGrafico,
  ]);



  //#endregion


  //#region HISTORICO
  const handleOpenChangeHistory = useCallback((
    idTabela: number | null,
    tipoTabela: LogTipoTabela | null,
  ) => {
    if (idTabela && tipoTabela) {
      changeHistory.handleOpenChangeHistory(idTabela, tipoTabela, false);
    } else {
      if (true) {
        changeHistory.handleOpenChangeHistory(idTabela ?? 0, LogTipoTabela.ENTREGA_OBRA_CLIENTE_ARQUIVO, true);
      }
    }
  }, [
    changeHistory,
  ]);

  //#endregion
  return {
    loading,
    saving,
    errorMessage,
    entregaObraParametros,
    selectedIdEntregaObra,
    arquivosLista,
    vistoriasLista,
    selectedArquivo,
    openCadastroArquivosModal,
    openDeleteArquivosModal,
    openCadastroVistoriasModal,
    openDeleteVistoriasModal,
    filters,
    pagination,
    reportViewerState,
    ddlCliente,
    filteredChecklistEntregaObraDropdown,
    openReportFotoModal,
    openReportGeralModal,
    changeHistory,
    openGraficoModal,
    estatisticasChecklist: estatisticasChecklist ?? null,

    ddlChecklistEntregaObra,
    ddlClienteReport,
    ddlUnidadeReport,
    ddlChecklistReport,
    ddlLocalVistoriaReport,

    handleGraficoOpenState,
    handleReportGeralOpenState,
    handleReportFotoOpenState,
    handleReportSimple,
    handleReportFotografico,
    handleReportGeral,
    handleItemVerificacaoPage,
    handleIdsChecklistChange,
    handleIdsClienteChange,
    handleLocalVistoriaChange,
    handleEntregueChange,
    handleUnidadeChange,
    handleTipoVistoriaChange,
    handleClearFilters,
    handleDataRangeChange,
    handlePageBack,
    handleNewContaPagar,
    handleVistoriaOpenState,
    handleSubmitNewVistoria,
    handleArquivoModalOpenState,
    handleArquivoDeleteOpenState,
    handleSubmitNewArquivo,
    handleDeleteArquivoOpenState,
    handleSubmitDeleteArquivo,
    handleDeleteVistoriaOpenState,
    handleSubmitDeleteVistoria,
    handleReload,
    handlePageChange,
    handleRowsPerPageChange,
    handleDownloadArquivo,
    handleOpenChangeHistory,
    startReportViewerProcess,

  }
};
